import { createAsyncAction } from '@/redux/root';

export const nameSpace = '@@/aspyn-migrator';

export const clearCacheOfAspynPushesAsync = createAsyncAction(`${nameSpace}/CLEAR_CACHE_OF_ASPYN_PUSHES`);

export const requestMigrationJobsAsync = createAsyncAction(`${nameSpace}/REQUEST_MIGRATION_JOBS`);

export const migrateRepsAsync = createAsyncAction(`${nameSpace}/MIGRATE_REPS`);

export const migrateHousingAsync = createAsyncAction(`${nameSpace}/MIGRATE_HOUSING`);

export const getPatAsync = createAsyncAction(`${nameSpace}/GET_PAT`);

export const updatePatAsync = createAsyncAction(`${nameSpace}/UPDATE_PAT`);

export const removePatAsync = createAsyncAction(`${nameSpace}/DELETE_PAT`);
